import { configureStore } from '@reduxjs/toolkit';
import { getState, saveState } from 'library/local-storage';
import { socketMiddleware } from './middleware/socket';
import rootReducer from './redux/root.reducer';
import { activeStageTimerMiddleware } from './middleware/activeStageTimer';
var preloadedState = getState() ? getState() : {};
// Middleware that wraps each action dispatch in a try/catch so stack
// overflows and other errors are reported with the offending action type.
var errorReportingMiddleware = function () { return function (next) { return function (action) {
    try {
        return next(action);
    }
    catch (err) {
        console.error("Redux dispatch error for action type \"".concat(action === null || action === void 0 ? void 0 : action.type, "\":"), err);
        throw err;
    }
}; }; };
export var store = configureStore({
    reducer: rootReducer,
    preloadedState: preloadedState,
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({
            serializableCheck: false,
        }).concat(socketMiddleware, activeStageTimerMiddleware, errorReportingMiddleware);
    },
});
store.subscribe(function () {
    saveState(store.getState());
});
